module.exports = __webpack_public_path__ + "img/case_08.d59d5a79.jpg";